// http://vuex.vuejs.org/en/getters.html
import { isEmpty } from 'lodash'

// if has token, we assume that user is logged in our system
export const isLogged = ({ token }) => !isEmpty(token)

// get current user data
export const currentUser = ({ user }) => user

export const currentToken = ({ token }) => token

export const isShopFloorWorker = ({ user }) => {
  return user && !!user.isShopFloorWorker
}

export const globalMetadata = ({ user }) => {
  return user ? user.metadata : null
}

export const mainMenu = ({ user }) => {
  return user && user.mainMenu && user.mainMenu.length > 0
    ? user.mainMenu
    : []
}

// True only for the original tenant admin who registered via /api/auth/signup.
// Used to gate billing/subscription UI per the "Subscription / billing visibility rule" in CLAUDE.md.
export const isSignupAdmin = ({ user }) => {
  return !!(user && user.requiresEmailVerification === true)
}

// --- Free-tier feature ---------------------------------------------------
// /auth/me (loaded by the loadUser action) stores its data block FLAT as
// state.auth.user (== the currentUser getter), so the tier fields live at
// currentUser.tier / .tierLimits / .tierUsage — NOT under a tenant sub-object.

// Treat a missing tier defensively as 'Free' (most-restrictive default).
export const isFreeTier = ({ user }) => (user?.tier ?? 'Free') === 'Free'

// Per-tier caps from the backend: { users, workcenters, workers, documents, storageBytes, archiveDays }.
export const tierLimits = ({ user }) => user?.tierLimits

// Current consumption against those caps: { users, workcenters, workers, documents, storageBytes }.
export const tierUsage = ({ user }) => user?.tierUsage

// Billing / upgrade UI visibility gate. REUSES the existing self-signup-admin
// rule (isSignupAdmin) so only the original self-signup tenant admin sees
// tier / upgrade UI — everyone else gets the plain "contact admin" path.
export const showBillingUi = (state, getters) => getters.isSignupAdmin

// Single source of truth for account-level warnings. Each entry: { id, messageKey, severity }.
// Only self-signup users surface billing/subscription-tied warnings.
export const accountWarnings = ({ user }) => {
  if (!user || isEmpty(user)) return []
  if (!user.requiresEmailVerification) return []  // workers / admin-created users never get billing warnings

  const warnings = []

  if (user.emailConfirmed === false) {
    warnings.push({
      id: 'email-unverified',
      messageKey: 'Please verify your email address',
      severity: 'warning',
    })
  }

  // ADD FUTURE WARNING CONDITIONS HERE (e.g. trial expiring, payment failed)

  return warnings
}

export const hasAccountWarnings = (state, getters) => getters.accountWarnings.length > 0
